import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-list-vna-services',
  templateUrl: './list-vna-services.component.html',
  styleUrls: ['./list-vna-services.component.scss']
})
export class ListVnaServicesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna_services/components/list-vna-services/list-vna-services.component.ts